import { ref } from 'vue';
import { useIntersectionObserver } from '@vueuse/core';
import { point } from "@/utils/pointUtils";
import { showYoutubeVideo } from './popupHook';
import websiteConfig from '@/configs/websiteConfig';
const list = websiteConfig.role.list
const langDiff = websiteConfig.role.langDiffs
const roleMenuName = list.map(item => item.name); // 板块目录
const roleSectionRef = ref(null);
let roleViewActive = false;
useIntersectionObserver(roleSectionRef, ([{ isIntersecting }]) => {
  if (!roleViewActive && isIntersecting) {
    roleViewActive = true;
    point({
      eventName: 'view_page',
      eventType: '角色展示',
    });
  }
});
const roleRef = ref(null);
const targetIsVisible = ref(false);
const { isSupported } = useIntersectionObserver(roleRef, ([{ isIntersecting }], observerElement) => {
  targetIsVisible.value = isIntersecting;
});
export default function () {
  const audioState = ref(false);
  const handleMedia = (detail) => {
    let nowMediaType = detail.mediaType
    point({
      eventName: 'click_button',
      eventType: '角色列表',
      eventReason: '媒体播放-' + detail.name,
    })
    if (nowMediaType === 'video') {
      showYoutubeVideo(detail.url)
      return;
    }
    if (nowMediaType === 'audio') {
      const audio = new Audio(detail.url);
      if (audioState.value) {
        audio.pause();
        audio.currentTime = 0;
        audioState.value = false;
        return;
      }
      audio.play();
      audioState.value = true;
      audio.addEventListener("ended", function() {
        // 当音轨播放完毕时候做你想做的事情
        audioState.value = false;
      });
    }
  }
  const outsideSwiperConfig = {
    el: '.type-pagination',
    clickable: true,
    bulletClass: 'type-nav-item',
    bulletActiveClass: 'active',
    renderBullet: function (index, className) {
      return `
                <a href="javascript:void(0)" class="${className}" data-reason="role" data-type="role-${roleMenuName[index]}">
                      <span class="text">${roleMenuName[index]}</span>
                </a>`;
    },
  };
  const generateRolePagination = (detail) => {
    const avatarArr = detail.map(item => item.avatar)
    return {
      el: '.avatar-pagination',
      clickable: true,
      bulletClass: 'avatar',
      bulletActiveClass: 'active',
      renderBullet: function (index, className) {
        return `
                <a href="javascript:void(0)" class="${className}" style="background-image: url(${avatarArr[index]})" data-reason="roleDetail" data-type="role-${index}"></a>`;
      },
    }
  }
  return {
    outsideSwiperConfig,
    roleRef,
    roleSectionRef,
    targetIsVisible,
    isSupported,
    handleMedia,
    audioState,
    websiteConfig,
    generateRolePagination,
    langDiff
  };
}
